<template>
  <section>
    <div class="container support-section">
      <div class="has-text-centered top-container px-4">
        <h2 class="title">
          {{ $t("aokPlus.title") }}
        </h2>
        <p v-if="healthInsurance === HealthInsurances.aokPlus">{{ $t("aokPlus.weAnswer") }}</p>
        <p v-else-if="healthInsurance === HealthInsurances.aokRps">
          {{ $t("aokRps.weAnswer") }}
        </p>
        <p v-else>{{ $t("mobil.weAnswer") }}</p>
      </div>
      <HealthInsuranceQuestionsSection :health-insurance="healthInsurance" />
      <div class="other-questions-container">
        <h3 class="title">
          {{ $t("aokPlus.stillQuestions") }}
        </h3>
        <p class="my-3">
          {{ $t("aokPlus.willHelp") }}
        </p>
        <p class="title is-3">0331 769 950 33</p>
        <p v-if="healthInsurance !== HealthInsurances.mobil" class="my-3">
          {{ healthInsurance === HealthInsurances.aokRps ? $t("aokRps.otherQuestion") : $t("aokPlus.otherQuestion") }}
          {{ $t("aokPlus.orVisit") }}
          <u>
            <a href="https://www.aok.de/pk/kontakt/aok-vor-ort/" target="_blank">
              {{
                healthInsurance === HealthInsurances.aokRps ? $t("aokRps.serviceCenter") : $t("aokPlus.serviceCenter")
              }}
            </a>
          </u>
        </p>
      </div>
      <div v-if="healthInsurance === HealthInsurances.aokPlus" class="more-info">
        <div>
          <div>
            <img alt="Informations-Icon" src="~assets/images/utils/info.svg" width="32" height="32" />
          </div>
          <a target="_blank" href="https://www.aok.de/pk/plus/gesundheits-apps-kosten/">
            {{ $t("aokPlus.moreInfoAboutAOK") }}
          </a>
        </div>
        <div>
          <img
            src="~/assets/images/utils/arrow-right-rounded.svg"
            alt="Pfeil nach rechts"
            width="32"
            height="32"
            @click="openAOKPlusPage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HealthInsurances from "../../models/healthInsurances.js"
import HealthInsuranceQuestionsSection from "~/components/healthInsurance/HealthInsuranceQuestionsSection.vue"

export default {
  name: "HealthInsuranceSupportSection",
  components: { HealthInsuranceQuestionsSection },
  props: {
    healthInsurance: {
      type: String,
      default: HealthInsurances.aokPlus,
    },
  },
  computed: {
    HealthInsurances() {
      return HealthInsurances
    },
    aokRps() {
      return aokRps
    },
  },
  methods: {
    openAOKPlusPage() {
      window.open("https://www.aok.de/pk/plus/gesundheits-apps-kosten/", "_blank")
    },
  },
}
</script>

<style scoped lang="scss">
.support-section {
  margin-top: 120px;
  margin-bottom: 120px;
}

.top-container {
  h4 {
    color: $brandpurple;
    font-weight: 600;
  }
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
}

.other-questions-container {
  background-color: #f9fafb;
  text-align: center;
  padding: 2rem;
  margin-bottom: 60px;
  margin-top: 60px;
  .title {
    font-weight: 600;
    font-size: 1.25rem;
  }
}
.more-info {
  background-color: #f9fafb;
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 1rem;
  img {
    vertical-align: middle;
    margin-right: 1rem;
    cursor: pointer;
    width: 32px;
    height: 32px;
    @media screen and (max-width: $mobile) {
      width: 20px;
      height: 20px;
    }
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  a {
    color: inherit;
  }
}
</style>
